import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { IOrderClause } from '../../ServerApi/types/IOrderClause';
import { OrderKeys } from '../OrderKeys';
import { OptionDefinition, OptionsDictionary } from './SortOptionDefinitions';


export const backgroundJobsSortOptions: OptionsDictionary = {
    [OrderKeys.jobId]: SortOptionHelper(
        OrderKeys.jobId,
        Messages.column_backgroundJob_id,
        Messages.sortByIdAsc,
        Messages.sortByIdDesc,
        Messages.sortByLowest,
        Messages.sortByHighest
    ),
    [OrderKeys.status]: SortOptionHelper(
        OrderKeys.status,
        Messages.column_backgroundJob_status,
        Messages.sortByStatusAsc,
        Messages.sortByStatusDesc,
    ),
    [OrderKeys.priority]: SortOptionHelper(
        OrderKeys.priority,
        Messages.column_backgroundJob_priority,
        Messages.sortByPriorityAsc,
        Messages.sortByPriorityDesc,
        Messages.sortByLowest,
        Messages.sortByHighest,
    ),
    [OrderKeys.taskType]: SortOptionHelper(
        OrderKeys.taskType,
        Messages.column_backgroundJob_taskType,
        Messages.sortByTypeAsc,
        Messages.sortByTypeDesc,
    ),
    [OrderKeys.jobRequestedTime]: SortOptionHelper(
        OrderKeys.jobRequestedTime,
        Messages.column_backgroundJob_jobRequestedTime,
        Messages.sortByJobRequestedTimeAsc,
        Messages.sortByJobRequestedTimeDesc,
        Messages.sortByOldest,
        Messages.sortByNewest,
    ),
    [OrderKeys.currentRunTime]: SortOptionHelper(
        OrderKeys.currentRunTime,
        Messages.column_backgroundJob_runTime,
        Messages.sortByRunTimeAsc,
        Messages.sortByRunTimeDesc,
        Messages.sortByShortest,
        Messages.sortByLongest,
    ),
    [OrderKeys.currentQueueTime]: SortOptionHelper(
        OrderKeys.currentQueueTime,
        Messages.column_backgroundJob_queueTime,
        Messages.sortByQueueTimeAsc,
        Messages.sortByQueueTimeDesc,
        Messages.sortByShortest,
        Messages.sortByLongest,
    ),
};


function SortOptionHelper(
    key: string,
    menuItemDisplayValue: () => string,
    buttonDisplayAscending: () => string,
    buttonDisplayDescending: () => string,
    menuItemDisplayValueAscending: () => string = Messages.sortByAZ,
    menuItemDisplayValueDescending: () => string = Messages.sortByZA,
    toOrderClauseArrayAscending: () => ReadonlyArray<IOrderClause> = () => [Order.asc(key)],
    toOrderClauseArrayDescending: () => ReadonlyArray<IOrderClause> = () => [Order.desc(key)],
): OptionDefinition {
    return {
        id: key,
        getMenuItemDisplayValue: menuItemDisplayValue,
        subSortOptions: {
            'asc': {
                id: key + '.asc',
                field: key,
                getMenuItemDisplayValue: menuItemDisplayValueAscending,
                getButtonDisplayValue: buttonDisplayAscending,
                ascending: true,
                toOrderClauseArray: toOrderClauseArrayAscending,
            },
            'desc': {
                id: key + '.desc',
                field: key,
                getMenuItemDisplayValue: menuItemDisplayValueDescending,
                getButtonDisplayValue: buttonDisplayDescending,
                ascending: false,
                toOrderClauseArray: toOrderClauseArrayDescending,
            }
        }
    };
}
